export default __webpack_public_path__ + "static/media/bg_login.aa114af1.jpg";